import Carousel from '../carousel'
import { EVEntry } from '@uswitch/ev-core/react'

export default ({ entries = [], colsMobile = 2, colsTablet = 2, colsDesktop = 2 }) => {
  return (
    <Carousel colsDesktop={colsDesktop} colsMobile={colsMobile} colsTablet={colsTablet}>
      <For each='entry' of={entries} index='i'>
        <EVEntry {...entry} />
      </For>
    </Carousel>
  )
}
